
import React from "react";
import { withRouter } from 'react-router'

// as per: https://reacttraining.com/react-router/web/guides/scroll-restoration

class ScrollToTopWithout extends React.Component {

  componentDidUpdate(prevProps) {
    // console.log('ScrollTop did update', this.props, prevProps);
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    return this.props.children
  }
}

const ScrollToTop = withRouter(ScrollToTopWithout)

export { ScrollToTop };



// WEBPACK FOOTER //
// ./src/includes/ScrollToTop.jsx